// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"37b4d097","67":"a2432d1d","323":"3c59ba3f","333":"a06be5eb","447":"a4cc57b3","461":"cd91742e","487":"c74b6c97","490":"062cec35","511":"83fa5bae","534":"a629dcf7","563":"2bb4d203","794":"169fd5ee","859":"84a8669e","896":"0e98da44"}[chunkId] + ".chunk.js";
};